import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TestDataAgentSSEComponent } from './test-data-agent-sse.component';

const routes: Routes = [
  {
    path: 'test-data-agent-sse',
    component: TestDataAgentSSEComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TestDataAgentSSERoutingModule {}
